// Empresas.js
import React, { useEffect, useState } from "react";
import user_plomo from "../images/user_plomo.png";
import mensaje_azul from "../images/correo_azul.png";
import { ApiService } from "../components/ApiService";
import Skeleton from "@mui/material/Skeleton";
import { ModalAddMensajeSolicitud } from "../components/Modales/ModalAddMensajeSolicitud";
import logo_empresa_default from "../images/logo_empresa_default.jpg"
import { useNavigate } from "react-router-dom";
import { returnFullURL, useProovedorData } from "../components";
import CorreoSendIcon from "../svg/CorreoSendIcon";
import { ImagenesGlobal } from "../components/global/ImagenesGlobal";
import CallApi from "../data/CallApi";


export const Empresas = () => {
	const API_url = process.env.REACT_APP_API_URL; // Ej: "http://192.168.0.22:8000/"
	const { listCompanies, setListCompanies, loading, loadImageS } = useProovedorData();

	const [selectedCategory, setSelectedCategory] = useState("Comercios");
	const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
	const [selectedCompanyIndex, setSelectedCompanyIndex] = useState(null);
	const navigate = useNavigate();

	const handleCategoryClick = (category, e) => {
		e.preventDefault();
		setSelectedCategory(category);
	};

	async function loadCompanys() {
		const response = await CallApi({
			url: "api/company/list"
		});

		if (Array.isArray(response)) setListCompanies(response);
	}

	useEffect(() => {
		if (Array.from(listCompanies ?? []).length == 0) loadCompanys();
	}, []);


	const handleSendRequest = async (authCode, index, message) => {
		try {
			const token = localStorage.getItem("token");

			const bodySend = {
				company: authCode,
				user_message: message || "ninguno", // Include the message
			};

			const options = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"Authorization": `Bearer ${token}`,
				},
				body: JSON.stringify(bodySend),
			};

			const response = await ApiService.fetchData("api/company/request/discount", options, API_url);

			if (response && response.code === 200) {
				setListCompanies((prev) => {
					const updated = [...prev];
					updated[index] = { ...updated[index], request: "waiting" };
					return updated;
				});
			}
		} catch (error) {
			console.error("Error sending request:", error);
		}
	};
	if (loading) {
		return (
			<div className="global-view-1fix">
				<div className="global-options data-global">
					<div className="accion-icons">
						{[1, 2, 3].map((item) => (
							<div className="user-session" key={item}>
								<Skeleton variant="circular" width={24} height={24} />
								<Skeleton variant="text" width={80} />
							</div>
						))}
					</div>
				</div>

				<div className="content-view-company">
					<div className="content-title-company">
						<Skeleton sx={{ marginLeft: 5 }} variant="text" width={250} height={40} />
					</div>

					<div className="content-article-company">
						{[1, 2, 3, 4, 5, 6].map((item) => (
							<div className="card-company" key={item}>
								<div className="image-company">
									<Skeleton variant="rectangular" width="100%" height={120} />
								</div>
								<div className="txt-company">
									<div>
										<Skeleton variant="text" width="80%" height={28} />
									</div>
									<div>
										<Skeleton variant="text" width="60%" />
									</div>
									<div className="content-btn-company">
										{/*<Skeleton variant="circular" width={24} height={24} />*/}
										<Skeleton variant="rectangular" width={120} height={36} />
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		);
	}
	const handleOpenMessageModal = (authCode, index) => {
		const token = localStorage.getItem("token");
		if (!token) {
			alert("Debes iniciar sesión para enviar una solicitud.");
			setListCompanies((prev) => {
				const updated = [...prev];
				updated[index] = { ...updated[index], request: "auth" };
				return updated;
			});
			return;
		}

		setSelectedCompanyIndex(index);
		setIsMessageModalOpen(true);
	};
	const handleSaveMessage = async (message) => {
		if (selectedCompanyIndex !== null) {
			const company = listCompanies[selectedCompanyIndex];
			await handleSendRequest(company?.authCode, selectedCompanyIndex, message);
		}
	};

	const styles_icons = {
		padding: '6px',
		borderRadius: '50%',
		overflow: 'hidden',
		fontSize: 'var(--same-size) !important',
		width: 'var(--same-size)',
	};

	function redirectCompany(nit = null) {
		navigate("company/products?search=" + nit);
	}

	const respuestas = {
		denied: 'Denegado',
		accepted: 'Aceptado',
		none: 'Enviar solicitud',
		waiting: 'En Espera...',
		auth: 'Autenticar...'
	}

	return (
		<div className="global-view-1fix">
			<div className="global-options data-global">
				<ul className="data-profile">
					<li>
						<img src={user_plomo} alt="user" style={styles_icons} />
						<span className="normal-black text-bold">Servicios</span>
					</li>

					<li className="option-selected">
						<img src={user_plomo} alt="user" style={styles_icons} />
						<span className="normal-black text-bold">Comercios</span>
					</li>

					<li>
						<img src={user_plomo} alt="user" style={styles_icons} />
						<span className="normal-black text-bold">Industriales</span>
					</li>
				</ul>
			</div>

			<div className="content-view-company">
				<div className="content-title-company">
					<h2>Empresas de Bolivia - {selectedCategory}</h2>
				</div>

				<div className="content-article-company">
					{listCompanies.map((company, index) => (
						<div className="cards-company shadow-lvl6" key={index} onClick={() => redirectCompany(company?.codeVisit ?? null)}>
							<div className="image-company">
								<ImagenesGlobal url={company?.profile} type="picture" alt={company?.name} loadImageS={loadImageS} />
							</div>
							<div className="txt-company">
								<div>
									<h3>{company?.name}</h3>
								</div>
								<div>
									<span>{company?.location || "Ubicación desconocida"}</span>
								</div>

								<button
									className='default-buttons'
									onClick={(e) => {
										e.stopPropagation();
										if (company?.request == 'none') handleOpenMessageModal(company?.authCode, index);
									}}
									style={{ backgroundColor: `rgba(24, 67, 247,${company?.request != 'none' ? '0.7' : '1'})` }}
									disabled={company?.request != 'none'}
								// style={{back}}
								>
									<CorreoSendIcon color='#fff' fondo='transparent' main_css={{ width: '40px', zIndex: '10' }} />
									<span style={{ color: '#fff', fontSize: '18px', fontWeight: '550' }}>
										{respuestas[company?.request] ?? "No Autorizado"}
									</span>
								</button>
							</div>
						</div>
					))}
				</div>
			</div>
			<ModalAddMensajeSolicitud
				open={isMessageModalOpen}
				onClose={() => setIsMessageModalOpen(false)}
				onSave={handleSaveMessage}
			/>
		</div >
	);
};

// const fullLogo = company?.logo ? API_url + company?.logo : logo_empresa_default;
